<template>
  <t-table :class="['bg-white shadow-none', className]" :headers="headers" :data="data">
    <!-- Loading skeleton -->
    <template v-if="isLoading" v-slot:tbody="props">
      <tbody :class="props.tbodyClass">
        <tr v-for="index in 10" :key="`skeleton-${index}`" :class="props.trClass">
          <td :class="[props.tdClass, 'text-center']">
            <div class="w-8 h-4 mx-auto bg-gray-200 rounded animate-pulse"></div>
          </td>
          <td
            v-for="(header, headerIndex) in headers.slice(1)"
            :key="`skeleton-cell-${index}-${headerIndex}`"
            :class="props.tdClass"
          >
            <div class="h-4 bg-gray-200 rounded animate-pulse" :class="getSkeletonWidth(headerIndex)"></div>
          </td>
          <td :class="[props.tdClass, 'text-center']">
            <div class="w-16 h-4 mx-auto bg-gray-200 rounded animate-pulse"></div>
          </td>
        </tr>
      </tbody>
    </template>

    <!-- No data -->
    <!-- <template v-else-if="!data.length" v-slot:tbody="props">
      <tbody :class="props.tbodyClass">
        <tr :class="[props.trClass, 'text-center']">
          <td :class="props.tdClass" colspan="15">
            <div role="status" class="flex items-center justify-center h-72">
              <svg aria-hidden="true"
                class="w-8 h-8 text-center text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="currentColor" />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentFill" />
              </svg>
              <span class="items-center text-center sr-only">Loading...</span>
            </div>
          </td>
        </tr>
      </tbody>
    </template> -->
    <template v-else-if="!data.length" v-slot:tbody="props">
      <tbody :class="props.tbodyClass" class="custom-m-height">
        <tr v-if="withCreateButton">
          <td :colspan="columnCount" class="text-left create-cell">
            <slot name="create-button">
              <button @click="handleCreate" class="btn btn-primary">
                Create New
              </button>
            </slot>
          </td>
        </tr>
        <tr :class="[props.trClass, 'text-center']">
          <td :class="props.tdClass" colspan="15">
            <div class="flex flex-col items-center justify-center flex-nowrap h-96">
              <svg width="35" height="35" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M36.014 19.1452L29.5936 25.5656L36.014 31.986C36.524 32.5141 36.8063 33.2214 36.7999 33.9555C36.7935 34.6897 36.499 35.3919 35.9799 35.9111C35.4608 36.4302 34.7585 36.7247 34.0243 36.7311C33.2902 36.7375 32.5829 36.4552 32.0548 35.9452L25.6344 29.5248L19.214 35.9452C18.9557 36.2126 18.6467 36.4259 18.3051 36.5727C17.9635 36.7194 17.5961 36.7967 17.2243 36.7999C16.8525 36.8031 16.4838 36.7323 16.1397 36.5915C15.7956 36.4507 15.483 36.2428 15.2201 35.9799C14.9572 35.717 14.7493 35.4044 14.6085 35.0603C14.4677 34.7162 14.3969 34.3475 14.4001 33.9757C14.4033 33.6039 14.4806 33.2365 14.6273 32.8949C14.7741 32.5532 14.9874 32.2443 15.2548 31.986L21.6752 25.5656L15.2548 19.1452C14.7448 18.6171 14.4625 17.9098 14.4689 17.1757C14.4753 16.4415 14.7698 15.7392 15.2889 15.2201C15.8081 14.701 16.5103 14.4065 17.2445 14.4001C17.9786 14.3937 18.6859 14.6759 19.214 15.186L25.6344 21.6064L32.0548 15.186C32.5829 14.6759 33.2902 14.3937 34.0243 14.4001C34.7585 14.4065 35.4608 14.701 35.9799 15.2201C36.499 15.7392 36.7935 16.4415 36.7999 17.1757C36.8063 17.9098 36.524 18.6171 36.014 19.1452Z"
                  fill="#4B5563" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M11.3775 46.8856C15.5875 49.6986 20.5371 51.2 25.6003 51.2C32.3876 51.1924 38.8947 48.4928 43.694 43.6935C48.4934 38.8942 51.193 32.3872 51.2006 25.6C51.2006 20.5368 49.6992 15.5873 46.8862 11.3774C44.0732 7.16751 40.075 3.8863 35.3971 1.94869C30.7193 0.011092 25.5719 -0.495873 20.6059 0.491908C15.64 1.47969 11.0784 3.91785 7.49817 7.49807C3.9179 11.0783 1.47971 15.6398 0.491914 20.6057C-0.495879 25.5716 0.0110922 30.7189 1.94872 35.3967C3.88634 40.0745 7.1676 44.0726 11.3775 46.8856ZM14.9332 9.63579C18.0907 7.52607 21.8029 6.40001 25.6003 6.40001C30.691 6.40509 35.5717 8.42957 39.1713 12.0292C42.7709 15.6288 44.7955 20.5094 44.8005 25.6C44.8005 29.3974 43.6745 33.1095 41.5647 36.2669C39.455 39.4244 36.4563 41.8853 32.9479 43.3385C29.4395 44.7917 25.579 45.1719 21.8545 44.4311C18.1301 43.6902 14.7089 41.8616 12.0237 39.1764C9.3385 36.4913 7.50986 33.0702 6.76901 29.3457C6.02817 25.6213 6.4084 21.7608 7.86162 18.2525C9.31484 14.7441 11.7758 11.7455 14.9332 9.63579Z"
                  fill="#4B5563" />
                <path
                  d="M58.5382 63.0624C59.1382 63.6626 59.952 63.9998 60.8006 64C61.4335 63.9999 62.052 63.8121 62.5781 63.4605C63.1043 63.1089 63.5143 62.6091 63.7565 62.0245C63.9986 61.4399 64.062 60.7965 63.9385 60.1759C63.8151 59.5552 63.5105 58.9851 63.0631 58.5376L50.2629 45.7376C49.6594 45.1547 48.8511 44.8322 48.012 44.8394C47.173 44.8467 46.3704 45.1833 45.7771 45.7766C45.1837 46.3699 44.8472 47.1725 44.8399 48.0115C44.8326 48.8506 45.1552 49.6589 45.7381 50.2624L58.5382 63.0624Z"
                  fill="#4B5563" />
              </svg>
              <h4 class="mb-0 text-base text-gray-600">No results found</h4>
              <p class="text-sm text-gray-500">Change your keyword or filter</p>
            </div>
          </td>
        </tr>
      </tbody>
    </template>

    <!-- Table Head -->
    <template v-slot:thead="props">
      <thead class="sticky-header">
        <tr>

          <th v-if="withNumberCol" :class="[props.thClass, 'table-header-number text-center text-xs font-semibold']">No</th>

          <th
            v-for="(header, index) in headers.slice(1)"
            :key="index"
            :class="[props.thClass, header.class]"
            :style="header.style"
          >
            <template v-if="header.slotHeader">
              <slot :name="header.slotHeader" :column="header" />
            </template>

            <template v-else>
              <div class="flex items-center gap-1">
                {{ header.label || header }}

                <button
                  v-if="header.sortable"
                  @click="$emit('sort', header.key)"
                  class="text-xs text-gray-500 hover:text-black"
                >
                  ⬍
                </button>
              </div>
            </template>
          </th>

          <th v-if="withAction" :class="props.thClass" class="px-5 text-center"></th>
        </tr>
      </thead>
    </template>

    <!-- Table Body -->
    <template v-slot:row="props">
      <tr v-if="withCreateButton && props.rowIndex === 0">
        <td :colspan="columnCount" class="text-left create-cell">
          <slot name="create-button">
            <button @click="handleCreate" class="btn btn-primary">
              Create New
            </button>
          </slot>
        </td>
      </tr>

      <tr>
        <td v-if="withNumberCol" :class="[props.tdClass, 'text-center']">
          <template v-if="withPagination">
            {{ (currentPage - 1) * perPage + props.rowIndex + 1 }}
          </template>
          <template v-else>
            {{ props.rowIndex + 1 }}
          </template>
        </td>
        <td
          v-for="(key, index) in rowKey"
          :key="index"
          :class="props.tdClass"
          class="capitalize"
        >
          <template v-if="$scopedSlots[key]">
            <slot :name="key" :value="props.row[key]" :row="props.row" :index="props.rowIndex" />
          </template>
          <template v-else>
            {{ props.row[key] || '-' }}
          </template>
        </td>
        <td v-if="withAction" :class="[props.tdClass, 'text-center']">
          <!-- Custom slot untuk actions -->
          <slot name="actions" :row="props.row" :index="props.rowIndex" />
        </td>
      </tr>
    </template>
  </t-table>

</template>

<script>
export default {
  name: 'Table',
  props: {
    headers: Array,
    data: Array,
    rowKey: Array,
    currentPage: Number,
    perPage: Number,
    className: String,
    isLoading: {
      type: Boolean,
      default: false
    },
    withNumberCol: {
      type: Boolean,
      default: true
    },
    withAction: {
      type: Boolean,
      default: true
    },
    withPagination: {
      type: Boolean,
      default: true
    },
    withCreateButton: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    columnCount () {
      let count = this.headers.length;
      if (this.withAction) {
        count++;
      }
      if (this.withNumberCol) {
        count++;
      }

      return count;
    }
  },
  methods: {
    getSkeletonWidth(index) {
      const widths = ['w-16', 'w-24', 'w-32', 'w-20', 'w-28', 'w-12', 'w-36'];
      return widths[index % widths.length];
    },
    handleCreate() {
      this.$emit('create');
    }
  }
};
</script>

<style scoped>
.table-header-number {
  min-width: 3.5rem;
}

.create-cell {
  text-align: center;
  padding: 1rem;
  background-color: #f8f9fa;
  border-bottom: 2px solid #dee2e6;
}
.custom-m-height {
  height: 600px;
}
</style>
